export default __webpack_public_path__ + "static/media/image.elysian-crest.ba01ae29.png";